import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/icons/nft-info.svg'
import _imports_1 from '@/assets/images/icons/close_24.svg'


const _hoisted_1 = { class: "nft-card-info-comp" }
const _hoisted_2 = {
  key: 0,
  class: "nft-card-info-header"
}
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "header-close" }
const _hoisted_6 = { class: "nft-card-info-item-list" }
const _hoisted_7 = { class: "nft-card-info-item-section" }
const _hoisted_8 = {
  key: 0,
  class: "nft-card-info-item mb-16"
}
const _hoisted_9 = { class: "nft-card-info-title mb-8" }
const _hoisted_10 = { class: "nft-card-info-content" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "info-row mb-4" }
const _hoisted_13 = { class: "info-col" }
const _hoisted_14 = {
  key: 0,
  class: "nft-card-info-content"
}
const _hoisted_15 = {
  key: 1,
  class: "nft-card-info-content"
}
const _hoisted_16 = { class: "info-row" }
const _hoisted_17 = { class: "info-col" }
const _hoisted_18 = { class: "nft-card-info-content" }
const _hoisted_19 = {
  key: 1,
  class: "info-col"
}
const _hoisted_20 = {
  key: 1,
  class: "nft-card-info-item"
}
const _hoisted_21 = { class: "nft-card-info-title mb-8" }
const _hoisted_22 = { class: "info-col" }
const _hoisted_23 = { class: "nft-card-info-item-section" }
const _hoisted_24 = { class: "nft-card-info-item" }
const _hoisted_25 = { class: "nft-card-info-title mb-12" }
const _hoisted_26 = { class: "nft-card-info-content" }
const _hoisted_27 = { class: "nft-card-info-item-section" }
const _hoisted_28 = { class: "nft-card-info-item" }
const _hoisted_29 = { class: "nft-card-info-title mb-12" }
const _hoisted_30 = { class: "nft-card-info-content" }
const _hoisted_31 = { class: "nft-card-info-item-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MvPageTab = _resolveComponent("MvPageTab")!
  const _component_NftCardQtnrInfoComp = _resolveComponent("NftCardQtnrInfoComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("nftCard.precautionTitle")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _imports_1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSlide && _ctx.closeSlide(...args)))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isQtnr)
      ? (_openBlock(), _createBlock(_component_MvPageTab, {
          key: 1,
          selected: _ctx.selectedInfo,
          "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedInfo) = $event)),
          tabs: [
                {
                  name: 'nftCard.precaution.tabs.nft',
                  value: 'nft',
                },
                {
                  name: 'nftCard.precaution.tabs.attendee',
                  value: 'attendee',
                },
            ],
          class: "mb-16"
        }, null, 8, ["selected", "tabs"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.data.sellYn !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("nftCard.precaution.reSale.title")), 1),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.data.sellYn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('payDetail.maxPrice')), 1),
                        (_ctx.data.maxPrice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t(_ctx.currency.i18nUnit, [_ctx.data.maxPrice.toLocaleString()])), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, " - "))
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('payDetail.royalties')), 1),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.data.royalty) + "% ", 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t("nftCard.precaution.unAvail")), 1))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.transferYn !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("nftCard.precaution.transfer.title")), 1),
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.data.transferYn ? _ctx.$t("nftCard.precaution.avail") : _ctx.$t("nftCard.precaution.unAvail")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("nftCard.precaution.description.title")), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", null, _toDisplayString(_ctx.data.description ? _ctx.data.description : _ctx.$t("nftCard.precaution.description.empty")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("nftCard.precaution.considerations.title")), 1),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", null, _toDisplayString(_ctx.data.memo ? _ctx.data.memo : _ctx.$t("nftCard.precaution.considerations.empty")), 1)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.isQtnr || _ctx.selectedInfo === 'nft']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_31, [
      _createVNode(_component_NftCardQtnrInfoComp, {
        "qtnr-info": _ctx.data.qtnrInfo,
        "qtnr-template": _ctx.data.qtnrTemplate
      }, null, 8, ["qtnr-info", "qtnr-template"])
    ], 512), [
      [_vShow, _ctx.selectedInfo === 'attendee']
    ])
  ]))
}